export default "__VITE_ASSET__ZzBt7R7N__"